import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { ENV_CONSTANTS, environment } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { LocalStorageProps } from '../enums/localStorageProps';
import { CleverTapEventsService } from './clevertap-events-service';
import { DcgroupcodePickerService } from './dcgroupcode-picker.service';
import { GlobalService } from './global.service';
import { LocalStorageSvc } from './localStorage.service';
import { ActiveRepo } from './universal.service';



@Injectable()
export class InterceptorService implements HttpInterceptor {
  public headers: any;
  private router;
  private http;
  private toastr;
  private universalService;
  loggerService: any;
  localStorageSvc: LocalStorageSvc;
  userData: any;
  listService: any;
  cleverTapEventsService: CleverTapEventsService;
  db: IndexedDBModule;
  shareAccessService: any;
  redirectionService: any;
  userloginController: any;
  sessionStorageService:any;
  dcGroupCodePicker: DcgroupcodePickerService;
  constructor(public globalService: GlobalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.redirectionService = globalService.getRedirectionServiceRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    this.db = IndexedDBModule.getInstance(globalService);
    this.userloginController = UserloginController.getInstance(this.globalService);


  }
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.localStorageSvc.getUserData() == undefined) {
      //this.clearStore() 
      this.headers = {
        "X-Api-Key": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"],
        "X-Client-Details": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Client-Details"],
        "X-App-Secret": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"],
        
      }
     
      this.clearStore();

    } else {
      this.userData = this.localStorageSvc.getUserData(true);
      //const deviceKey = (this.localStorageSvc.getDeviceKey(true)) ? this.localStorageSvc.getDeviceKey(true) : this.userData["deviceKey"]
      const deviceKey = this.userData["deviceKey"]
      //const userId = (this.localStorageSvc.getUserId(true)) ? (this.localStorageSvc.getUserId(true)) : this.userData["userId"]
      const userId = this.userData["userId"]
      const Authorization = window.btoa(this.userData['authToken'].accessToken);

    
      this.headers = {
        "Authorization": "Basic " + Authorization,
        "X-User-Id": userId,
        "X-Device-Key": deviceKey,
        "X-Api-Key": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"],
        "X-Client-Details": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Client-Details"],
        "X-App-Secret": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"],
      }
    }

    
    this.headers["Accept"] = ENV_CONFIG.commonHeaders["Accept"]
    this.headers["X-Device-Type"] = ENV_CONFIG.commonHeaders["X-Device-Type"]

    
    // if(request.url.includes(ENV_CONFIG["commonUrls"]["ssoJCLogin"])){
    //   this.headers["X-App-Secret"] = ENV_CONSTANTS["JC_SSO_LOGIN_APP_SECRET"];
    // }

    // IN APP TRASH VIEW FOR ANDROID AND IOS STARTS
    let authorization = this.userData ? window.btoa(this.userData['authToken'].accessToken) : "";
    //let userId = (this.localStorageSvc.getUserId(true)) ? (this.localStorageSvc.getUserId(true)) : (this.userData ? this.userData["userId"] : undefined)
    let userId = (this.userData ? this.userData["userId"] : undefined)
    //const deviceKey = (this.localStorageSvc.getDeviceKey(true)) ? this.localStorageSvc.getDeviceKey(true) : (this.userData ? this.userData["deviceKey"] : undefined)
    const deviceKey = (this.userData ? this.userData["deviceKey"] : undefined);
    let nativeHeaders = this.localStorageSvc.getLocalProperty('nativeHeaders',true);
    if ((userId || nativeHeaders) && this.universalService.userLoggedIn && this.universalService.inAppWebViewOpened) {
      this.getCommonHeadersForLoggedInUser(authorization, userId, nativeHeaders, deviceKey);
    }
    // IN APP TRASH VIEW FOR ANDROID AND IOS ENDS

    if (!request["url"].includes("/upload/files") && !request["url"].includes("/user/csv")) {
      this.headers["Content-Type"] = ENV_CONFIG.commonHeaders["Content-Type"]
    }

    //Add 'X-Share-Key' header for upload from /shared menu
    if ((request["url"].includes("/upload/files")) && (this.router.url.includes('/shared/')) && this.universalService.allowUpload) {
      var sharedFolderDetails = this.localStorageSvc.getSharedFolder(true);
      this.universalService.isUploadFromShare = true;
      this.headers["X-Share-Key"] = sharedFolderDetails.shareKey;
    } else if (request["url"].includes("amiko/cab/contacts/search")) {
      this.headers["X-CHUNK-SIZE"] = '5000';
      this.headers["X-Offset"] = '0';
      //  this.headers["nextPageDate"] = this.universalService.nextPageDate;
      this.headers["DEVICE-OS"] = 'Android';
    } else if (request["url"].includes("amiko/cab/contacts")) {
      this.headers["X-CHUNK-SIZE"] = '' + this.universalService.contactChunkSize + '';
      this.headers["X-Offset"] = '' + this.universalService.contactOffet + '';
      this.headers["nextPageDate"] = this.universalService.nextPageDate;
      this.headers["DEVICE-OS"] = 'Android';
    } else if (request["url"].includes("/2fa/disable") || request["url"].includes('/2fa/validation')) {

      this.headers["X-Enc-2FAHash"] = this.universalService.enc2FAHash;
    } else if (request["url"].includes("/logout")) {
      this.clearStore();
    }
    // For contact search
    if (request["url"].includes("/amiko/cab/contacts/search")) {
      this.headers["X-Offset"] = "0";
      this.headers["X-Chunk-Size"] = "5000";
    }

    // For file info comments pagination, additional parameter
    if (request["url"].includes("/collshare/comments") && request["method"].includes("GET")) {
      if (this.universalService.finalLastUpdatedDateOfResponse > 0) {
        this.headers["If-Modified-Since"] = "" + this.universalService.finalLastUpdatedDateOfResponse;
      }
    }
    if (request.headers.getAll('X-Offset'), request.headers.get('Content-MD5'), request.headers.get('Content-Type'), request.headers.get('processData')) {
      this.headers['X-Offset'] = request.headers.getAll('X-Offset'),
        this.headers['Content-MD5'] = request.headers.getAll('Content-MD5'),
        this.headers['Content-Type'] = request.headers.getAll('Content-Type'),
        this.headers['processData'] = request.headers.getAll('processData')
    }

    if (request.headers.get('If-Modified-Since')) {
      this.headers['If-Modified-Since'] = request.headers.get('If-Modified-Since')
    }

    if (request["url"].includes('nonce/validate')) {
      var Authorization = window.btoa(this.userData['authToken'].accessToken);
      this.headers = {
        "Authorization": "Basic " + Authorization,
        "X-Api-Key": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"],
        "X-Client-Details": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Client-Details"],
        "X-App-Secret": ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"],
      }
    }

    if ((request["url"].includes("/pulink")) || (request["url"].includes("/unishr/objects"))) {
      // check if sessionID cookie is there or not
      if (this.sessionStorageService.getUnivShareLinkSessionID()) {
        this.headers['X-Ulinks-Token'] = this.sessionStorageService.getUnivShareLinkSessionID();
      }
    }
    // console.log("174 interceptor request[url]::",request["url"])
    // if(request["url"].includes("/unishr/") && request["url"].includes("pdfrender=y")){
    //   let cookieHeader = "appSecret_jc="+ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"]+";ulk_"+this.sessionStorageService.getUnivShareLinkShareKey()+this.sessionStorageService.getUnivShareLinkSessionID()
    //   console.log("177 interceptor cookieHeader::",cookieHeader)

    //   this.headers['Cookie'] = cookieHeader;
    // }
    
    if ( !request["url"].includes("/validatepwd") &&  ( (this.universalService.currentTab == "PrivateFolder"  && this.universalService.popUpToBeOpened == "movePopUp") || request["url"].includes("/ppf") || this.universalService.isPrivateFolderTokenRequired == true ))  {   
    //if ( !request["url"].includes("/validatepwd") &&  ( request["url"].includes("/ppf") || this.router.url.includes("privatefolder") ||  this.universalService.isPrivateFolderTokenRequired == true ))  { //
      this.headers['X-PPF-TOKEN'] =  this.universalService.header_X_PPF_TOKEN; 
      this.universalService.isPrivateFolderTokenRequired = false;
    }

    let newURL = request["url"];
    if(request["url"].includes("i18n/en-US.json") || request["url"].includes("i18n/hi-IN.json")){
      newURL += "?av=" + environment.appVersion;
    }

    if(newURL.charAt(0) == "/" && !newURL.includes("assets") && window.location.origin.includes("local")){
      newURL = environment.baseUrl + newURL;
    }

    //if(request["url"].includes("/activitylogs")){
    //  this.headers['x-time-zone'] =   Intl.DateTimeFormat().resolvedOptions().timeZone;
    //}
    // this.universalService.showLoader = true;
    request = request.clone({
      url: newURL,
      headers: new HttpHeaders(this.headers)
    });

    return next.handle(request)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            // if (!(event.url.includes("/pulink") || event.url.includes(".json") || event.url.includes("/app/settings?os=web"))) {
            if (!(event.url.includes("/pulink") || event.url.includes(".json") || event.url.includes("/app/settings?os=web") || event.url.includes("app/version?os=web") || event.url.includes("pnr"))) {
              this.localStorageSvc.setRefreshTokenTime(new Date().getTime());
            }
            this.universalService.isServerError = false;
            // this.universalService.showLoader = false;
          }
        }), (catchError((error) => {
          // this.universalService.showLoader = false;
          if (error instanceof HttpErrorResponse) {
            if (this.universalService.inAppWebViewOpened) {
              console.log("error from catch", error);
              return throwError(error);
            }
            else {

              if (error.status == 409) {
                return throwError(error);
              } else if (error.status == 403 && this.localStorageSvc.getUserData() != undefined && this.userData.jcEntInfo && error["error"]['code'] == "TEJVF0001") {
                this.universalService.showToast(TOAST["ADMIN_CONSOLE_ACCESS_ERROR"], "error");
                window.location.href = "/home"

              }else if(error.status == 412 && this.localStorageSvc.getUserData() != undefined && this.userData["isStaySignIn"] == true && error.error.code == "SCLN0141"){
                this.refreshToken(request);
              }
              else if (error.status == 400 && this.localStorageSvc.getUserData() != undefined
                && (error.error.code == "NMSCL0021" || error["error"]['code'] == "NMSCL0024" || error.error.code == "TASCL0020") || (error.error.code == "NMSOM0021" || error.error.code == "NMSOM0064" || error.error.code == "TFOM0020")) {
                this.universalService.showLoader = false;
                if (error["error"]['code'] == "NMSCL0024") {
                  this.universalService.showToast(TOAST["FILE_DOES_NOT_EXIST"], "error");
                } else if (error["error"]['code'] == "NMSCL0021") {
                  this.universalService.showToast(TOAST["REQUEST_ACCESS"], "error");
                } else if (error.error.code == "NMSOM0021" || error.error.code == "NMSOM0064") {
                  if (!request.url.includes(ENV_CONFIG["commonUrls"]["createFolder"].toString()) && !request.url.includes(ENV_CONFIG["commonUrls"]["createPrivateFolder"].toString()))
                    this.universalService.showToast(error.error.error, "error");
                } else if (error["error"]['code'] == "TASCL0020") {
                  this.universalService.showToast(TOAST["REFRESH_REQUIRED"], "error");
                } else if (error["error"]['code'] == "TFOM0020") {
                  if(this.universalService.inAppWebViewOpened) {
                  }else if(this.router.url.includes('teamfolders')){
                    this.universalService.showToast(TOAST["TF_UNAUTHORIZED"], "error");
                    window.location.href = "/home";
                  }else if(this.router.url.includes('allfiles')){
                    this.universalService.showToast(TOAST["TF_UNAUTHORIZED"], "error");
                    this.router.navigate(['allfiles']);
                  }
                } else {
                  this.universalService.showToast(error.error.error, "error");
                }
                return throwError(error);
              } else if (this.localStorageSvc.getUserData() != null && request.url.indexOf('logout') == -1) {
                if (request.url.indexOf('refresh') >= 0 &&
                  (error.error['code'] == "SCLN0068" || error.error['code'] == "TEJVF0002" ||
                    error.error['code'] == "SCLN0101" || error.error['code'] == "TEJGA0400")) { //|| error.error['code'] == "SCLN0057"
                  clearInterval(this.universalService.pingcall)
                  this.logout();
                  this.showError();
                  this.universalService.disableModalBackdrop();
                  console.log("server error in interceptor", error.error['code'])
                  if(this.universalService.activeRepo == ActiveRepo.MAIN){
                    this.router.navigate(['/']);
                  }
                }else if (request.url.indexOf('refresh') >= 0 &&
                (error.error['code'] == "SCLN0057" )) { //|| error.error['code'] == "SCLN0057"
                  let lastRefresh = localStorage.getItem('lastRefreshTime');
                  let currentTime = new Date().getTime();
		              let hours = (currentTime - parseInt( lastRefresh)) / 3600000;
                  //const expiresIn = this.localStorageSvc.getTokenExpiryDuration(true)/(1.2 * 60 * 60);
                  const expiresIn = this.userData["authToken"]["expiresIn"]/(1.2 * 60 * 60);
                  //if (lastRefresh!=null && hours > expiresIn){/* during passphrase opened state , refresh api throwing error SCLN0057 but user not logout so commented this condition */
                    clearInterval(this.universalService.pingcall)
                    this.logout();
                    this.showError();
                  //}
                } else if (this.userData["isStaySignIn"] == true && request.url.indexOf('refresh') == -1 && error.status == 401 && error.error.code != "AMIKOUnAuthorizedAccess") {
                  this.refreshToken(request);
                 } else if (this.universalService.selectedTab == 'Album Details' && (error.error.code == "BRSOM0110" || error.error.code == "BINVS0003")) {
                  this.universalService.showLoader = false;
                  var msg = ""
                  this.universalService.showToast(TOAST["USER_NOT_PART_OF_ALBUM"], "error")
                  setTimeout(() => {
                    if(this.universalService.currentAlbum["isShareAlbum"]){
                      this.router.navigate(['/albums/sharedalbums'])
                      return
                    }
                    this.router.navigate(['/albums/myalbums']);
                  }, 4000);
                } else if (request.url.indexOf('refresh') == -1 && error.status == 401
                  && !((window.location.href.includes('localhost') || window.location.href.includes('dev-') || window.location.href.includes('sit-') || window.location.href.includes('pp-')) && error.error['code'] == "AMIKOUnAuthorizedAccess")
                ) {

                  clearInterval(this.universalService.pingcall)
                  this.logout();
                  this.showError();
                  this.universalService.disableModalBackdrop();
                  if( window.location.href.includes('/waves')){
                    this.universalService.waveRegister = true;
                  }
                  else if (this.universalService.activeRepo == 'main') {
                    this.router.navigate(['/']);
                  } else if (this.universalService.activeRepo == 'invite') {
                    window.location.href = "/";
                  }
                } else if (error.status == 401
                  && request.url.indexOf('login') == -1 && error.error.code != "AMIKOUnAuthorizedAccess") {


                  clearInterval(this.universalService.pingcall)
                  this.logout()

                  console.log("server error in interceptor", error.status)
                  if (this.universalService.ignoreUnAuthorizedError) {
                    // this.cookie.delete('u');
                    this.universalService.disableModalBackdrop();

                    return throwError(error);
                  }
                  this.showError();
                  if( window.location.href.includes('/waves')){
                    this.universalService.waveRegister = true;
                  }
                  else if (this.universalService.activeRepo == 'main') {
                    this.router.navigate(['/']);
                  } else if (this.universalService.activeRepo == 'invite') {
                    window.location.href = "/";
                  }
                  if (this.universalService.activeRepo == 'share') {
                    window.open('/', "_self", "noopener, noreferrer");
                  }
                  this.universalService.disableModalBackdrop();
                } else if (error.status == 400 && this.localStorageSvc.getUserData() == undefined
                  && request.url.indexOf('login') == -1 && error.error.code != "NMSCL0029" && error.error.code != "NMSCL0011") {
                  clearInterval(this.universalService.pingcall)
                  this.logout()
                  this.showError();

                  this.router.navigate(['/']);
                  this.universalService.disableModalBackdrop();
                }
              } else {
                console.log("inAppWebViewOpened :: ", request);
                if (error.status == 401 && !this.universalService.ignoreUnAuthorizedError) {
                  if (this.universalService.inAppWebViewOpened) {
                    setTimeout(() => {
                      this.listService.informAndroidAndIOSToCloseWebView("");
                    }, 2000);
                  } else {
                    this.logout();
                    this.showError();
                  }
                } else if (error.status == 400 && (error.error.code == "NMSOM0021" || error.error.code == "NMSOM0064")) {
                  this.universalService.showToast(error.error.error, "error");
                }
              }

              var ERR = typeof (error["error"]) == 'string' ? JSON.parse(error["error"]) : error["error"];
              if (ERR['code'] && ERR['code'] == "SSOM0111") {
                return this.refreshUnivShareLinkSessionID(request, next);

              }
              else {
                //return throwError(error);
              }
              return throwError(error);
            }
          }
        }))
      )

  }

  async refreshToken(request) {
    this.universalService.refreshTokenInprocess = true;
    this.universalService.invokeRefresh = true;
    await this.userloginController.refreshData(true, true, true);
    if(this.universalService.show2FApopUp)
      return;
    let cUrl = this.universalService.targetUrl;
    if (this.universalService.targetUrl == "" || this.universalService.targetUrl.includes(" "))
      cUrl = this.router.url;
    this.universalService.targetUrl = "";
    if (cUrl == '/'){
      this.router.navigate(['/'], {queryParamsHandling: 'preserve'});
    }else{
      this.router.navigate([cUrl], {queryParamsHandling: 'preserve'});
      window.location.reload();
    }
    
    /* this.router.navigateByUrl('/',{skipLocationChange:true}).then(()=>{
        this.router.navigate(['/'+cUrl]).then(()=>{
          
        })
      })*/
    
  }

  async showError() {
    if (localStorage.getItem("univSharelinkSessionID") == null) {
      localStorage.clear();
    } else {
      this.universalService.userLoggedIn = false;
      this.clearLocalStorage()
    }
    // this.universalService.hideLeftMenu = true;
    this.universalService.showToast(TOAST["SESSION_EXPIRED"], "error");
    this.universalService.showLoader = false;
    this.universalService.show2FApopUp = false;
    this.universalService.showRecoverpopUp = false;
    this.universalService.showRecoverVerifyemailpopUp = false;
    this.universalService.recoverVerifyOTPpopUp = false;
    $('#custome_backdrop').remove();
  }
  logout() {
    let classRef = this;
    const userData = this.localStorageSvc.getUserData(true);
    if (window.location.href.includes('share') || window.location.href.includes('?u')) {
      this.universalService.userLoggedIn = false;
      this.universalService.setWidthforLogin();
      localStorage.removeItem(LocalStorageProps.TWOFA_ENABLED);
      localStorage.removeItem(LocalStorageProps.JIO)
      localStorage.removeItem(LocalStorageProps.BANNER_DETAILS)
      localStorage.removeItem(LocalStorageProps.PROFILE_PHOTO);
      localStorage.removeItem(LocalStorageProps.PROFILE_PHOTO_WITH_APIKEY);
      localStorage.removeItem(LocalStorageProps.RECOVER_DATA);
      localStorage.removeItem(LocalStorageProps.SHARE_PUBLIC_SORT);
      localStorage.removeItem("previousSharePublicSort")
      localStorage.removeItem("userType")
      if (this.listService.listOptions.api != undefined) {
        this.listService.listOptions.api.sizeColumnsToFit()
      }
      return;
    }
    localStorage.removeItem(LocalStorageProps.TWOFA_ENABLED);
    localStorage.removeItem('passPhraseValidationSuccess');
    localStorage.removeItem(LocalStorageProps.RECOVER_DATA);
    localStorage.removeItem('listViewSortOrderShare');
    localStorage.removeItem('listViewSortOrder');
    sessionStorage.removeItem('redirectedRoute');
    setTimeout(function () {
      classRef.universalService.iframeLogin = false;
      localStorage.removeItem(LocalStorageProps.LAST_REFRESH_TIME);
      localStorage.removeItem(LocalStorageProps.JIO);
      localStorage.removeItem(LocalStorageProps.PRIVATE_FOLDER_KEY);
      localStorage.removeItem(LocalStorageProps.PRIVATE_FOLDER_PASSWORD);
      localStorage.removeItem(LocalStorageProps.REFERRAL_DETAILS);
      localStorage.removeItem(LocalStorageProps.DC_GROUP_CODE);
      if (userData) {
        localStorage.removeItem('isReferralPopupShown_' + userData.userId);
      }
      sessionStorage.removeItem(SessionStorageProps.CURRENT_PRIVATE_FOLDER_KEY);
      sessionStorage.removeItem(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME);
      this.redirectionService.removeRequestedUrlFromLocalStorage();
      if (classRef.localStorageSvc.getTwoFAEnable(true) == "Y" && localStorage.getItem("appunlockTime") === null && localStorage.getItem("appLockTime") === null) {
        localStorage.setItem('invalidPassPhraseCounter', ENV_CONSTANTS["constants"]["passPhraseattempts"].toString());
      }
      classRef.universalService.resetValuesBeforeReLogin();
      classRef.clearStore();
    }, 1000);

  }

  clearStore() {
    this.db.clearStore('AllFilesMetadata_Grid_Name_Asc');
    this.db.clearStore('AllFilesMetadata_Grid_Date_Desc');
    this.db.clearStore('AllFiles_FolderMetadata_Name_Asc');
    this.db.clearStore('AllFiles_FolderMetadata_Date_Desc');
    this.db.clearStore('AllFilesMetadata_List_Name_Asc');
    this.db.clearStore('AllFilesMetadata_List_Name_Desc');
    this.db.clearStore('AllFilesMetadata_List_Date_Asc');
    this.db.clearStore('AllFilesMetadata_List_Date_Desc');
    this.db.clearStore('AllFilesMetadata_List_Size_Asc');
    this.db.clearStore('AllFilesMetadata_List_Size_Desc');
    this.db.clearStore('AllFilesMetadata_List_Type_Asc');
    this.db.clearStore('AllFilesMetadata_List_Type_Desc');
    this.db.clearStore('NextLink');
    this.db.clearStore('PhotosMetadata_ObjectName');
    this.db.clearStore('PhotosMetadata_FileCreatedDate');
    this.db.clearStore('PhotosMetadata_CreatedDate');
    this.db.clearStore('VideosMetadata_ObjectName');
    this.db.clearStore('VideosMetadata_FileCreatedDate');
    this.db.clearStore('VideosMetadata_CreatedDate');
    this.db.clearStore('ContactsStore_Asc');
    this.db.clearStore('ContactsStore_Dsc');
    this.db.clearStore('MyAlbumsList');
    this.db.clearStore('SharedAlbumsList');
    this.db.clearStore('DocumentMetadata_Name_Asc');
    this.db.clearStore('DocumentMetadata_Name_Desc');
    this.db.clearStore('DocumentMetadata_Size_Asc');
    this.db.clearStore('DocumentMetadata_Size_Desc');
    this.db.clearStore('DocumentMetadata_Type_Asc');
    this.db.clearStore('DocumentMetadata_Type_Desc');
    this.db.clearStore('DocumentMetadata_FileCreatedDate_Asc');
    this.db.clearStore('DocumentMetadata_FileCreatedDate_Desc');
    this.db.clearStore('DocumentMetadata_CreatedDate_Asc');
    this.db.clearStore('DocumentMetadata_CreatedDate_Desc');
    this.db.clearStore('AudiosMetadata_Name_Asc');
    this.db.clearStore('AudiosMetadata_Name_Desc');
    this.db.clearStore('AudiosMetadata_FileCreatedDate_Asc');
    this.db.clearStore('AudiosMetadata_FileCreatedDate_Desc');
    this.db.clearStore('AudiosMetadata_CreatedDate_Asc');
    this.db.clearStore('AudiosMetadata_CreatedDate_Desc');
    this.db.clearStore('RecentFilesMetadata');
    this.db.clearStore('AllFilesMetadata_Grid_Name_Desc');
    this.db.clearStore('AllFilesMetadata_Grid_Date_Asc');
    this.db.clearStore('AllFilesMetadata_Grid_CreatedDate_Asc');
    this.db.clearStore('AllFilesMetadata_Grid_CreatedDate_Desc');
    this.db.clearStore('VideosMetadata_ObjectName_Desc');
    this.db.clearStore('VideosMetadata_FileCreatedDate_Asc');
    this.db.clearStore('VideosMetadata_CreatedDate_Asc');
    this.db.clearStore('PhotosMetadata_ObjectName_Desc');
    this.db.clearStore('PhotosMetadata_FileCreatedDate_Asc');
    this.db.clearStore('PhotosMetadata_CreatedDate_Asc');
    this.db.clearStore('AllFiles_FolderMetadata_Name_Desc');
    this.db.clearStore('AllFiles_FolderMetadata_Date_Asc');
  }

  clearLocalStorage() {
    localStorage.removeItem(LocalStorageProps.TWOFA_ENABLED);
    localStorage.removeItem(LocalStorageProps.JIO);
    localStorage.removeItem(LocalStorageProps.BANNER_DETAILS)
    localStorage.removeItem("userType")
    localStorage.removeItem(LocalStorageProps.PROFILE_PHOTO);
    localStorage.removeItem(LocalStorageProps.PROFILE_PHOTO_WITH_APIKEY);
    localStorage.removeItem(LocalStorageProps.RECOVER_DATA);
    // localStorage.removeItem(LocalStorageProps.EMAIL_ID);
    sessionStorage.removeItem(SessionStorageProps.CURRENT_PRIVATE_FOLDER_KEY);
    localStorage.removeItem(LocalStorageProps.PRIVATE_FOLDER_KEY);
    sessionStorage.removeItem(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME);
    localStorage.removeItem(LocalStorageProps.PRIVATE_FOLDER_PASSWORD);
    localStorage.removeItem("passPhraseValidationSuccess");
    localStorage.removeItem("entTourMainRepoNoadminSeen");
    localStorage.removeItem('listViewSortOrderShare');
    localStorage.removeItem('listViewSortOrder');

    let imagesExists = this.localStorageSvc.getShareImageExists(true);
    let audiosExists = this.localStorageSvc.getShareAudiosExists(true);
    let videosExists = this.localStorageSvc.getShareVideosExists(true);
    let othersExists = this.localStorageSvc.getShareOthersExists(true);

    this.localStorageSvc.setImageExists(imagesExists, true);
    this.localStorageSvc.setAudiosExists(audiosExists, true);
    this.localStorageSvc.setVideosExists(videosExists, true);
    this.localStorageSvc.setOthersExists(othersExists, true)



  }


  getCommonHeadersForLoggedInUser(authorization, userId, nativeHeaders, deviceKey) {
    this.universalService.testVariable = nativeHeaders["X-User-Id"] + ' ******* ' + userId;
    this.headers["X-User-Id"] = nativeHeaders ? nativeHeaders["X-User-Id"] : userId;
    this.headers["Authorization"] = nativeHeaders ? nativeHeaders["Authorization"] : "Basic " + authorization
    this.headers["X-Device-Key"] = nativeHeaders ? nativeHeaders["X-Device-Key"] : deviceKey
    this.headers["X-Api-Key"] = nativeHeaders ? nativeHeaders["X-Api-Key"] : ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"]
    this.headers["X-Client-Details"] = nativeHeaders ? nativeHeaders["X-Client-Details"] : ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Client-Details"]
    this.headers["X-App-Secret"] = nativeHeaders ? nativeHeaders["X-App-Secret"] : ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"]
    this.headers["X-Session-Id"] = nativeHeaders ? nativeHeaders["X-Session-Id"] : "-"
    this.headers["Accept-Language"] = nativeHeaders ? nativeHeaders["Accept-Language"] : "en";
    this.headers["X-Device-Type"] = nativeHeaders ? "M" : "M";
    this.headers["Content-Type"] = nativeHeaders ? nativeHeaders["Content-Type"] : ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["Content-Type"];
  }

  refreshUnivShareLinkSessionID(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return this.shareAccessService.getNewUnivShareSessionID().pipe(
      switchMap((resp) => {
        this.sessionStorageService.setUnivShareLinkSessionID(resp["ulinksToken"]);
        return next.handle(this.addUnivShareSessionIDHeader(request))
        
      }),
      catchError(err => {
        console.log("switchMap error = " + JSON.stringify(err));
        return throwError(() => new Error(err))
      })
    )
  }

  addUnivShareSessionIDHeader(request: HttpRequest<any>) {
    const id = this.sessionStorageService.getUnivShareLinkSessionID();
    var request = request.clone({
      setHeaders: {
        'X-Ulinks-Token': id
      }
    });
    return request;
  }

  getNewUnivShareSessionID(){
    var url = ENV_CONFIG.commonUrls["univShareNewSession"];
    this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url);
    var param = {
      "shareKey" :  this.shareAccessService.univShareKey,
      "password" : this.shareAccessService.univSharePswd
    };
    return this.http.post(url,param);
  }
}